"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-underscore-dangle */
const THREE = __importStar(require("three"));
const consts_1 = require("../consts");
class LightsHelper {
    constructor() {
        this._lights = [];
        this._lightsConfiguration = {};
        const ambientLight = new THREE.AmbientLight(consts_1.consts.LIGHT_COLOR, 0.35);
        this._lights.push(ambientLight);
        this._lightsConfiguration.ambient = ambientLight;
        const hemisphereLight = new THREE.HemisphereLight(consts_1.consts.LIGHT_COLOR, consts_1.consts.LIGHT_COLOR, 0.15);
        hemisphereLight.position.set(-200, -200, -50);
        this._lights.push(hemisphereLight);
        this._lightsConfiguration.hemisphere = hemisphereLight;
        const directionalLight = new THREE.DirectionalLight(consts_1.consts.LIGHT_COLOR, 0.25);
        directionalLight.position.set(200, 200, -100);
        directionalLight.castShadow = true;
        this._lights.push(directionalLight);
        this._lightsConfiguration.directionalAtFrontTopRightCorner = directionalLight;
        const directionalLight1 = new THREE.DirectionalLight(consts_1.consts.LIGHT_COLOR, 0.15);
        directionalLight1.position.set(200, 0, -20);
        directionalLight1.castShadow = true;
        this._lights.push(directionalLight1);
        this._lightsConfiguration.directionalOnRight = directionalLight1;
        const directionalLight2 = new THREE.DirectionalLight(consts_1.consts.LIGHT_COLOR, 0.15);
        directionalLight2.position.set(-200, 0, -20);
        directionalLight2.castShadow = true;
        this._lights.push(directionalLight2);
        this._lightsConfiguration.directionalOnLeft = directionalLight2;
        const directionalLight3 = new THREE.DirectionalLight(consts_1.consts.LIGHT_COLOR, 0.15);
        directionalLight3.position.set(0, -200, -20);
        directionalLight3.castShadow = true;
        this._lights.push(directionalLight3);
        this._lightsConfiguration.directionalOnFront = directionalLight3;
        const directionalLight4 = new THREE.DirectionalLight(consts_1.consts.LIGHT_COLOR, 0.15);
        directionalLight4.position.set(0, 200, -20);
        directionalLight4.castShadow = true;
        this._lights.push(directionalLight4);
        this._lightsConfiguration.directionalOnBack = directionalLight4;
    }
    get lights() {
        return this._lights;
    }
    get lightsConfiguration() {
        return this._lightsConfiguration;
    }
}
exports.default = LightsHelper;
